/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
const is = require("is_js");

const SERVICE_NAME = "ProvisionalDetailService";
const log: any = LoggerModule.getInstance();

export class ProvisionalDetailPageService {
  private static instance: ProvisionalDetailPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ProvisionalDetailPageService {
    if (!ProvisionalDetailPageService.instance) {
      ProvisionalDetailPageService.instance = new ProvisionalDetailPageService(
        props
      );
    }
    return ProvisionalDetailPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Feature Section Props
    compProps = await agent.getFeatureSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateKyc(args: any) {
    const agent = getAgent();
    return agent?.getUpdateKyc(args);
  }

  public async updatePayment(args: any) {
    const agent = getAgent();
    return agent.getUpdatePayment(args);
  }

  public formatPolicyDetail(args: any) {
    const agent = getAgent();
    return agent.getFormatPolicyDetailSync(args);
  }

  public formatTimeLineDetail(args:any) {
    const agent = getAgent();
    return agent.getFormatTimelineDetailSync(args);
  }

  public getTransactionList(args?:any) {
    const agent = getAgent();
    return agent.getGetTransactionListProps(args);
  }

  public cancelPolicy(args:any) {
    const agent = getAgent();
    return agent.getCancelPolicyStatus(args);
  }
  
}
